import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {GenericService} from "../../commons/generic.service";
import {ArquivoBlobDTO} from "../../model/arquivoBlob.dto";

@Injectable()
export class AutorizacaoDeAcessoService extends GenericService {
  protected url: string = environment.url;
  private relativePath = 'api/v1/cadastroBemDireito/';

  constructor(http: HttpClient) {
    super(http);
  }

  uploadFormAutorizacao(matricula: string, autorizado: string, arquivo: File): Observable<any> {
    const formData = new FormData();
    formData.append('autorizacao', arquivo);
    formData.append('matricula', matricula);
    formData.append('autorizado', autorizado);

    return this.postMethodFile(this.relativePath + 'upload-autorizacao', formData);
  }

  submitAuthorization(isChecked: boolean): Observable<any> {
    return this.http.post<any>(this.url + `api/v1/autorizacao-acesso`, {autorizado: isChecked});
  }

}
